import { render, staticRenderFns } from "./WechatLogin.vue?vue&type=template&id=e4172654&scoped=true&"
import script from "./WechatLogin.vue?vue&type=script&lang=ts&"
export * from "./WechatLogin.vue?vue&type=script&lang=ts&"
import style0 from "./WechatLogin.vue?vue&type=style&index=0&id=e4172654&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4172654",
  null
  
)

export default component.exports